import template from './bookmarked_searches_create.template.html?raw';
import 'angular';

angular
  .module('directives.bookmarkedSearchesCreate', [])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('bookmarkedSearchesCreate', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      scope: false
    };
  });
